import React, { Component } from 'react';
import Urls from '../../common/Urls';
import PdfViewer from "../Pdf/PdfViewer";

export default class EndStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataIsLoaded: false,
      dataIsLoading : false,
      membership : 0,
      errorMsg: "",
    };
    this.store = props.getStore();
  }

  componentDidMount() {
    fetch(Urls.createContract(), {
      method: 'POST',
      mode: "cors",
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(this.store)
    })
    .then(response => {
      if (response.ok) {
        response.json().then(json => {
          if (json.status === 200) {
            this.setState({
              dataIsLoaded: true,
              membership : json.membership
            });
          } else {
            this.setState({
              dataIsLoaded: true,
              errorMsg: json.message
            });
          }
        });
      } else {
        this.setState({
          dataIsLoaded: true,
          errorMsg: "Error on response -> " + JSON.stringify(response) 
        })
      }
    })
    .catch((error) => {
      this.setState({
        dataIsLoaded: true,
        errorMsg: JSON.stringify(error)
      })
    });
  }

  onFinish = () =>
      this.SaveAndGoToNextStep();

  SaveAndGoToNextStep(){
    this.store.membership = this.state.membership;
    this.props.updateStore({
      ...this.store,
      savedToCloud: false
    });

    this.props.jumpToStep(this.props.intStep+1);
  }



  componentWillUnmount() {}

  // not required as this component has no forms or user entry
  // isValidated() {}


  renderFinalView() {
    return (
        <div className="endstep">
          <PdfViewer membership={this.state.membership} onFinish={this.onFinish}/>
        </div>
    );
  }

  renderLoadingView() {
    return (
      <p className="endstep">Envoie des données sur le serveur...</p>
    );
  }

  renderErrorView() {
    return (
      <div>
        <h2 className="text-center">Une erreur est survenue !</h2>
        <p>Une erreur est survenue lors de l'envoie des données :</p>
        <p><i>{this.state.errorMsg}</i></p>
        <p>N'hésitez pas à nous envoyer le détail de l'erreur à l'addresse mail suivante <a href="mailto:support@mesavantagespara.com">support@mesavantagespara.com</a></p>
      </div>
    );
  }

  render() {
    if (!this.state.dataIsLoaded) {
      return this.renderLoadingView();
    } else if (this.state.errorMsg != "") {
      return this.renderErrorView();
    }
    else {
      return this.renderFinalView();
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Steps/EndStep.js